// Copyright 2024 Sorama B.V.
import { CompositeUnit } from "./CompositeUnit";
import { Currency } from "./Currency";
import { Time } from "./Time";
import { Unit, UnitType } from "./Unit";

export class Power extends UnitType {
    public static override typeName = "Power";

    public static watts: Unit = new Unit("W", 1, Power);
    public static kiloWatts: Unit = new Unit("kW", 1e3, Power);
    public static megaWatts: Unit = new Unit("MW", 1e6, Power);
}

export class PowerRate extends UnitType {
    public static override typeName = "PowerRate";

    public static wattsPerSecond: CompositeUnit = new CompositeUnit(Power.watts, Time.second, PowerRate);
    public static wattsPerMinute: CompositeUnit = new CompositeUnit(Power.watts, Time.minute, PowerRate);
    public static wattsPerHour: CompositeUnit = new CompositeUnit(Power.watts, Time.hour, PowerRate);
    public static kiloWattsPerHour: CompositeUnit = new CompositeUnit(Power.kiloWatts, Time.hour, PowerRate);
    public static megaWattsPerHour: CompositeUnit = new CompositeUnit(Power.megaWatts, Time.hour, PowerRate);
    public static kiloWattsPerYear: CompositeUnit = new CompositeUnit(Power.kiloWatts, Time.year, PowerRate, {
        aliases: ["kW/year"],
    });
}

export class PowerCost extends UnitType {
    public static override typeName = "PowerCost";

    public static euroPerKiloWatt: CompositeUnit = new CompositeUnit(Currency.EUR, Power.kiloWatts, PowerCost, {
        aliases: ["EUR/kW"],
    });
    public static usdPerKiloWatt: CompositeUnit = new CompositeUnit(Currency.USD, Power.kiloWatts, PowerCost, {
        aliases: ["USD/kW"],
    });
}
